import { Tools } from "plano_engine";

export const allPane = {
    label: {
        en: "All",
        fr: "Tous"
    },
    predicate: () => true
};

export const furniturePane = {
    label: {
        en: "Artworks",
        fr: "Artworks"
    },
    predicate: builder => {
        if (builder instanceof Tools.FavoriteItemBuilder) return false;

        for (const currentItem of builder.currentItems) {
            if (currentItem instanceof BoardCoverVisual || currentItem instanceof BoardFascia) return true;
        }
        return false;
    }
};

export const blankingGraphicPane = {
    label: {
        en: "Blanking Graphic",
        fr: "Visuels pré-vente"
    },
    predicate: builder => {
        // @todo: is this needed?
        // if (builder instanceof Tools.FavoriteItemBuilder) return false;

        for (const currentItem of builder.currentItems) {
            if (currentItem instanceof BoardBlankingGraphic) return true;
        }
        return false;
    }
};

export const modulesPane = {
    label: {
        en: "Modules",
        fr: "Modules"
    },
    predicate: builder => {
        if (builder instanceof Tools.FavoriteItemBuilder) return false;

        for (const currentItem of builder.currentItems) {
            if (currentItem instanceof BoardModule) return true;
        }
        return false;
    }
};

export const structurePane = {
    label: {
        en: "Structures",
        fr: "Structures"
    },
    predicate: builder => {
        if (builder instanceof Tools.FavoriteItemBuilder) return false;

        return !modulesPane.predicate(builder) && !furniturePane.predicate(builder);
    }
};



// WEBPACK FOOTER //
// ./src/plano/utils/panes.js